import * as React from 'react'

const SvgSaveIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8 3.5L12.5.2c-.2-.1-.3-.2-.5-.2H1.3C.6 0 0 .6 0 1.3v13.3c0 .8.6 1.4 1.3 1.4h13.3c.7 0 1.4-.5 1.4-1.2V4.1c0-.4-.1-.4-.2-.6zM5.3 1.3h5.3v3.3H5.3V1.3zm5.4 13.4H5.3V9.4h5.3l.1 5.3zm1.3 0V9.4c0-.7-.6-1.3-1.3-1.3H5.3C4.6 8 4 8.6 4 9.3v5.3H1.3V1.3H4v3.3C4 5.4 4.6 6 5.3 6h5.3c.8 0 1.4-.6 1.4-1.3v-3l2.7 2.7v10.4l-2.7-.1z"
      fill="#163250"
    />
  </svg>
)

export default SvgSaveIcon
